import React from 'react';
import { useGoogleFormModal } from '../App';

const SiteFooter = () => {
  const { openGoogleFormModal } = useGoogleFormModal();
  return (
    <footer className="site-footer">
      <div className="site-footer-bg-1 wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms"
        style={{ backgroundImage: "url(assets/images/shapes/site-footer-shape-1.png)" }}>
      </div>
      <div className="site-footer-bg-2 wow slideInRight" data-wow-delay="100ms" data-wow-duration="2500ms"
        style={{ backgroundImage: "url(assets/images/shapes/site-footer-shape-2.png)" }}>
      </div>
      <div className="site-footer__top">
        <div className="container">
          <div className="site-footer__top-inner">
            <div className="site-footer__top-left">
              <div className="site-footer__top-icon">
                <span className="icon-artificial-intelligence"></span>
              </div>
              <h3 className="site-footer__top-title">Ready to Create & Commune with Us?</h3>
            </div>
            <div className="site-footer__top-right">
              <button
                onClick={openGoogleFormModal}
                className="thm-btn site-footer__btn"
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  font: 'inherit',
                  cursor: 'pointer'
                }}
              >
                Join Our Community
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="site-footer__middle">
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
              <div className="footer-widget__column footer-widget__about">
                <div className="footer-widget__logo">
                  <a href="index.html"><img src="assets/images/c2_logo_yt.png" width="155" alt="C2 Community Logo" /></a>
                </div>
                <div className="footer-widget__about-text-box">
                  <p className="footer-widget__about-text">Stay connected with the C2 community. Subscribe for the latest updates, events, and opportunities.</p>
                </div>
                <form className="footer-widget__newsletter-form">
                  <div className="footer-widget__newsletter-input-box">
                    <input type="email" placeholder="Email address" name="email" />
                    <button type="submit" className="footer-widget__newsletter-btn"><img
                      src="assets/images/icon/footer-widget-newsletter-send-icon.png"
                      alt="" /></button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-xl-2 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
              <div className="footer-widget__column footer-widget__links clearfix">
                <h3 className="footer-widget__title">Links</h3>
                <ul className="footer-widget__links-list list-unstyled clearfix">
                  <li><a href="#about">About Us</a></li>
                  <li><a href="#values">Our Values</a></li>
                  <li><a href="#structure">Structure</a></li>
                  <li><a href="#membership">Membership</a></li>
                  <li><a href="#manifesto">Manifesto</a></li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
              <div className="footer-widget__column footer-widget__contact clearfix">
                <h3 className="footer-widget__title">Contact</h3>
                <ul className="footer-widget__contact-list list-unstyled clearfix">
                  <li>
                    <div className="icon">
                      <span className="icon-email"></span>
                    </div>
                    <div className="text">
                      <p><a href="mailto:createncommune@gmail.com">createncommune@gmail.com</a></p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-pin"></span>
                    </div>
                    <div className="text">
                      <p>A Hub for Creatives Across Africa</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
              <div className="footer-widget__column footer-widget__social-box clearfix">
                <div className="site-footer__social">
                  <a href="https://x.com/CreateNCommune" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                  <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
                  <a href="https://www.tiktok.com/@createncommune?is_from_webapp=1" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                  <a href="https://www.instagram.com/createncommune/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="site-footer__bottom">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="site-footer__bottom-inner">
                <p className="site-footer__bottom-text">© Copyright 2024 by <a
                  href="#!">Create & Commune</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
